import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/**
 * Action types & creators
 */
const { Types, Creators } = createActions({
  loadBankAccounts: ['partner'],
  loadBankAccountsSuccess: ['data'],
  updateBankAccount: ['partner', 'bank_accounting', 'data'],
  updateBankAccountSuccess: [],
  resetBankAccounts: []
});

export { Types };

export default Creators;

/**
 * Handlers
 */
const INITIAL_STATE = Immutable({
  loading: true,
  updating: false,
  data: {
    id: '',
    partner_id: '',
    document: '',
    account_digit: '',
    account_holder_name: '',
    account_number: '',
    account_type: '',
    bank_name: '',
    branch_digit: '',
    branch_number: '',
    bank: {
      bank_name: '',
      bank_ispb: '',
      bank_code: ''
    }
  }
});

const loadBankAccountsSuccess = (state, action) => ({
  ...state,
  loading: false,
  data: {
    ...INITIAL_STATE.data,
    ...action.data
  }
});

const resetBankAccounts = (state, action) => INITIAL_STATE;

const updateBankAccount = state => ({
  ...state,
  updating: true
});

const updateBankAccountSuccess = state => ({
  ...state,
  updating: false
});

/**
 * Reducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.LOAD_BANK_ACCOUNTS]: resetBankAccounts,
  [Types.LOAD_BANK_ACCOUNTS_SUCCESS]: loadBankAccountsSuccess,
  [Types.UPDATE_BANK_ACCOUNT]: updateBankAccount,
  [Types.UPDATE_BANK_ACCOUNT_SUCCESS]: updateBankAccountSuccess,
  [Types.RESET_BANK_ACCOUNTS]: resetBankAccounts
});
